import { EnumBadge } from '@mxa-argos/components/custom/enum-badge';
import { IconLabel } from '@mxa-argos/components/custom/icon-label';
import { SearchItemLayout } from '@mxa-argos/modules/search/components/search-item-layout';
import type { SearchResult } from '@mxa-argos/modules/search/hooks/use-resource-search';
import { CreditCard, RadioTower } from 'lucide-react';

interface Props {
  result: SearchResult;
}

export function SimSearchItem({ result }: Props) {
  return (
    <SearchItemLayout
      icon={CreditCard}
      primary={result.primary}
      secondary={
        result.secondary && <EnumBadge enumName="SimStatus" value={result.secondary} size="sm" />
      }
      tertiary={result.tertiary}
      quaternary={result.quaternary && <IconLabel icon={RadioTower} value={result.quaternary} />}
    />
  );
}
